import type { ReactNode } from 'react';

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** Inline: **жирный**. */
function formatInline(text: string): string {
  return escapeHtml(text).replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
}

function renderSimpleMarkdown(markdown: string): ReactNode {
  const normalized = markdown.trim().replace(/\r\n/g, '\n');
  if (!normalized) {
    return null;
  }

  const blocks = normalized.split(/\n{2,}/);
  const out: ReactNode[] = [];

  blocks.forEach((block: string, bi: number) => {
    const lines = block.split('\n');
    const listLines = lines.filter((ln: string) => ln.trimStart().startsWith('- '));
    if (listLines.length === lines.length && listLines.length > 0) {
      out.push(
        <ul key={`ul-${bi}`}>
          {listLines.map((ln: string, i: number) => (
            <li key={`li-${bi}-${i}`} dangerouslySetInnerHTML={{ __html: formatInline(ln.replace(/^\s*-\s+/, '')) }} />
          ))}
        </ul>,
      );
      return;
    }

    const html = lines.map((ln: string) => formatInline(ln)).join('<br />');

    out.push(<p key={`p-${bi}`} dangerouslySetInnerHTML={{ __html: html }} />);
  });

  return <>{out}</>;
}

export function MarkdownSection({ content, className }: { content: string; className?: string }): ReactNode {
  const node = renderSimpleMarkdown(content);
  if (node == null) {
    return null;
  }
  return <div className={className}>{node}</div>;
}
